const routesNames = {
  dashboardRoute: "/",
  credentialingTrackingRoute: "credentialing-tracking",
  affiliationTrackingRoute: "affiliation-tracking",
  affiliationTrackingLetter: "affiliation-tracking-letter",
  privilegeViewerRoute: "privilege-viewer",
};

export default routesNames;
